module.exports = __webpack_public_path__ + "img/verify.479ac85b.svg";